import lang from "../../utils/lang"
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import store from "../PDFEditor/store";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// export async function computeImageDimension(data) {
//   const image = new Image();
//   image.src = data;

//   return await new Promise((resolve) => {
//     image.onload = () => {
//       resolve([image.width, image.height]);
//     };
//   });
// }

/* eslint-disable no-unused-vars */
export async function clip(imageSrc, points, SCALE) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const img = new Image(620, 620);
  img.src = imageSrc;

  return await new Promise((resolve, reject) => {
    img.onload = drawPath;
    function drawPath() {
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      ctx.strokeStyle = "red";
      ctx.beginPath();
      for (let i = 0; i <= points.length; i++) {
        const p = points[i % points.length];
        ctx.lineTo(p.x * SCALE, p.y * SCALE);
      }
      ctx.stroke();
      ctx.clip();

      //   ctx.setTransform(1, -0.4 * 1, 0, 1, 0, 60);
      ctx.drawImage(img, 0, 0, 620, 620, 0, 0, 620, 620);
      document.getElementById("preview").replaceChildren(canvas);
      resolve({ data: canvas.toDataURL("image/png"), img });
    }
  });

  //   return canvas.toDataURL("image/png");
}

export const distance = (p1, p2) => {
  return +Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2).toFixed(3);
};

export const unitParser = (value, unit = true) => {
  if (!unit) {
    return +value?.toString?.()?.match(/(\d|\.)+/g)?.[0];
  }
  const hasUnit = value.toString().match(/[a-z A-Z]+/g)?.length;
  if (!hasUnit) value += "px";
  return value;
};

export const calculateDims = (aspectRatio, maxRatio) => {
  const landscape = isLandscape(aspectRatio);
  const height = landscape
    ? window.innerHeight
    : Math.floor(Math.min(window.innerWidth * aspectRatio, window.innerHeight * maxRatio));
  const width = landscape
    ? Math.floor(Math.min(window.innerHeight * aspectRatio, window.innerWidth * maxRatio))
    : window.innerWidth;
  return { width, height };
};

export const isLandscape = (aspectRatio) => window.innerWidth > window.innerHeight * aspectRatio;

export async function imageInit(img) {
  const image = new Image();
  image.src = img.data;
  return await new Promise((resolve) => {
    image.onload = () => {
      resolve(image);
    };
  });
}

export async function computeImageDimension(container, img, offset = { x: 260 + 110, y: 260 }) {
  if (!container) throw new Error("Container is required!");
  // console.log(container);
  const style = getComputedStyle(container);
  const cWidth = unitParser(style.width, false) - offset.x;
  const cHeight = unitParser(style.height, false) - offset.y;

  // console.log(cWidth, cHeight);
  const image = await imageInit(img);
  const [width, height] = [image.width, image.height];
  let [cropWidth, cropHeight] = [width, height];
  if (cropWidth > cWidth) {
    cropHeight = cropHeight * (cWidth / cropWidth);
    cropWidth = cWidth;
  }
  if (cropHeight > cHeight) {
    cropWidth = cropWidth * (cHeight / cropHeight);
    cropHeight = cHeight;
  }
  return { width: cropWidth, height: cropHeight };
}

export async function rotate(image, size, degrees = 90) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (typeof image.data === "string") {
    image = await imageInit(image);
  }

  canvas.width = image.height;
  canvas.height = image.width;

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((degrees * Math.PI) / 180);
  ctx.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);
  ctx.restore();

  return canvas.toDataURL();
}

export function Img(img) {
  this.img = img;
}
Img.prototype.imageInit = async function () {
  const image = new Image();
  image.src = this.img.data;
  return await new Promise((resolve) => {
    image.onload = () => {
      resolve([image.width, image.height]);
    };
  });
};
Img.prototype.computeImageDimension = async function (container, offset = { x: 260 + 110, y: 260 }) {
  if (!container) throw new Error("Container is required!");
  const style = getComputedStyle(container);
  const cWidth = unitParser(style.width, false) - offset.x;
  const cHeight = unitParser(style.height, false) - offset.y;

  const [width, height] = await this.imageInit();
  let [cropWidth, cropHeight] = [width, height];
  if (cropWidth > cWidth) {
    cropHeight = cropHeight * (cWidth / cropWidth);
    cropWidth = cWidth;
  }
  if (cropHeight > cHeight) {
    cropWidth = cropWidth * (cHeight / cropHeight);
    cropHeight = cHeight;
  }
  return { width: cropWidth, height: cropHeight };
};
Img.prototype.rotate = function () {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
};

export function dataUrlTobase64(data) {
  return data?.match(/(?<=base64,).*$/)?.[0];
}
const fileToBase64 = (file, parse) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(parseBase64(reader.result, parse));
    reader.onerror = (err) => reject(err);
  });
  export const parseBase64 = (data, parse = true) => {
    try {
      if (parse) {
        return data?.match(/(?<=base64,).*$/)?.[0] || data;
      }
      return data;
    } catch (err) {
      return data;
    }
  };
  
export const isBase64 = (str) => {
  const regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  return regex.test(parseBase64(str));
};
export const toBase64 = (data, format = "utf8", parse = false) => {
  switch (format) {
    case "file": {
      if (!data) return;
      if (isBase64(data)) return data;
      return fileToBase64(data, parse);
    }
    default: {
      try {
        return Buffer.from(data, format).toString("base64");
      } catch (err) {
        return null;
      }
    }
  }
};
export const getLanguageLookup = (options = []) => {
  return options.map((d) => {
    const patch = lang.find((s) => s.label === d.label);
    if (!patch) {
      // throw new Error("Something went Wrong");
      return null;
    }
    return {
      ...d,
      id: patch.id,
      name: patch.name,
      supportWebApi: patch.supportWebApi,
      keyboardLayout: patch.keyboardLayout,
    };
  });
};

export const getLangById = (id) => {
  // console.log(lang);
  // return (store.get("lang") || []).find((d) => d.value === id);
  return lang.find((d) => d.value === id)
};
